import React, { useState, useEffect } from "react";
import ProductsSlider from "../ProductsSlider";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import Headline from "~/assets/js/components/Typography/Headline";
import SliderProductCard from "../ProductCard/SliderProductCard";
import { useComplementaryStocks } from "~/assets/js/Api/ingredientsApi";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { SkeletonComplementaryProducts } from "~/assets/js/components/Loaders/SkeletonLoader";
import { useCartContext } from "~/assets/js/global/cartContext";

const ComplementaryProducts = ({ title, products }) => {
    const { cart, cartItems, cartLoading } = useCartContext();
    const [filteredProducts, setFilteredProducts] = useState([]);
    const cookie = useAreaCookie();
    const storeId = cookie && cookie.area && cookie.area.store_id;
    const isDiscoverMode = !storeId;

    const { inStockIds, isLoading } = useComplementaryStocks(storeId);

    // Do not display complementary products that are already in cart
    useEffect(() => {
        if (!cart || isDiscoverMode) {
            setFilteredProducts(products);
            return;
        }

        const itemsInCart =
            cartItems && cartItems.map((item) => item.product_id);

        const filteredProducts = products.filter((product) => {
            const isAvailableInStore =
                storeId &&
                product.available_in_stores.includes(storeId.toString());
            return (
                itemsInCart &&
                !itemsInCart.includes(product.product_id) &&
                (!product.store_specific_product || isAvailableInStore)
            );
        });

        setFilteredProducts(filteredProducts);
    }, [cart, isDiscoverMode]);

    if (!isDiscoverMode && (isLoading || cartLoading)) {
        return <SkeletonComplementaryProducts />;
    }

    return (
        <div className="complementary-products">
            <Headline size={5}>{i18n.t(title)}</Headline>
            {filteredProducts && (
                <ProductsSlider>
                    {filteredProducts.map((product) => {
                        // Do not display out of stock items
                        // but show all if in discover mode
                        if (
                            inStockIds.includes(product.product_id) ||
                            isDiscoverMode
                        ) {
                            return (
                                <SliderProductCard
                                    key={product.product_id}
                                    product={product}
                                    storeId={storeId}
                                />
                            );
                        }
                    })}
                </ProductsSlider>
            )}
        </div>
    );
};

ComplementaryProducts.propTypes = {
    title: PropTypes.string,
    products: PropTypes.array,
    cartItems: PropTypes.array,
};

export default ComplementaryProducts;
